module.exports = __webpack_public_path__ + "img/img-franquicias-restaurantes-multisucursal.a0eb0721.webp";